import { WheelOfFortune } from '~/actions/extraHTML/wheelOfFortune';
import { NotificationConfigType } from '~/actions/triggers/types';

export const getExtraHTML = (
  type: NotificationConfigType,
  params: any,
  configuration?: any
) => {
  return {
    FortuneWheelTriggerParameter: new WheelOfFortune(params, configuration),
    NotificationTriggerParameter: undefined,
  }[type];
};
